import { Component } from '../../../../component-decorator';
import { ModalObservacaoColetaController } from '../../modal/observacao-coleta/modal-observacao-coleta.controller';
import { ModalRemocaoObservacaoController } from '../../modal/remocao-observacao/modal-remocao-observacao.component';

@Component({
  componentName: 'appColetaObservacao',
  template: require('./coleta-observacao.component.html'),
  bindings: {
    pedido: '<',
    atualizar: '<',
    showAlert: '<',
  }
})
export class ColetaObservacaoComponent implements angular.IController {
  private user;
  public pedido;
  public atualizar: () => void;
  public showAlert: (msg) => void;

  constructor(localStorageService, private $uibModal) {
    'ngInject';

    this.user = localStorageService.get('user');
  }

  abrirModalObservacao() {
    if (this.user.situacao === 'BLOQUEADO') {
      this.$uibModal.open({
        animation: false,
        template: require('../../../modal/modal-servico-suspenso/modal-servico-suspenso.html'),
        controller: 'ModalServicoSuspensoCtrl',
        windowClass: 'agendamento-coleta-bloqueado',
          resolve: {
            redirectToEncomendas: () => false,
            nomeOperacao: () => 'a edição de observações',
          }
      });
    } else {
      this.$uibModal.open({
        animation: false,
        template: require('../../modal/observacao-coleta/modal-observacao-coleta.html'),
        controller: ModalObservacaoColetaController,
        windowClass: 'observacao-coleta',
        resolve: {
          pedidoId: () => this.pedido.id,
          observacao: () => this.pedido.observacao,
        }
      }).result.then((result) => {
        this.pedido.observacao = result.observacao;
      });
    }
  }

  removerObservacao() {
    if (this.user.situacao === 'BLOQUEADO') {
      this.$uibModal.open({
        animation: false,
        template: require('../../../modal/modal-servico-suspenso/modal-servico-suspenso.html'),
        controller: 'ModalServicoSuspensoCtrl',
        windowClass: 'agendamento-coleta-bloqueado',
        resolve: {
          redirectToEncomendas: () => false,
          nomeOperacao: () => 'a remoção de observações',
        }
      });
    } else {
      this.$uibModal.open({
        animation: false,
        template: require('../../modal/remocao-observacao/modal-remocao-observacao.html'),
        controller: ModalRemocaoObservacaoController,
        windowClass: 'removacao-observacao',
        resolve: {
          pedidoId: () => this.pedido.id,
        }
      })
      .result
      .then(() => {
        this.showAlert('As observações foram apagadas!');
        this.atualizar();
      });
    }
  }
}
